/**
 * The only place the custom-domains frontend reads `import.meta.env`. Kept tiny so jest (ts-jest CommonJS) can mock
 * the module instead of choking on `import.meta`.
 */

const LOCAL_BUILDER_API = /^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/;

/**
 * Builder Service base URL: the Load Balancer / local builder (VITE_BUILDER_API_URL), never the frontend origin and
 * never a direct Cloud Run URL (404).
 */
export function getBuilderApiUrl(): string {
  const url = import.meta.env.VITE_BUILDER_API_URL;
  if (!url) {
    throw new Error('VITE_BUILDER_API_URL is not configured');
  }
  return url;
}

/** Local http base URLs (http://localhost:8090/blog) are valid only while the frontend talks to a local builder. */
export function isLocalBuilderApi(): boolean {
  return LOCAL_BUILDER_API.test(import.meta.env.VITE_BUILDER_API_URL ?? '');
}
